<nav
  class="relative flex flex-wrap items-center justify-between py-2 transition-all ease-in duration-200 lg:flex-nowrap lg:justify-start"
  navbar-main
  navbar-scroll="false">
  <div
    class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between w-full lg:gap-4 self-stretch">
    <nav class="min-w-0" *ngIf="topbarHeader$ | async as topbarHeader">
      <div class="flex px-1 items-center gap-2 pb-4">
        <ng-container
          *ngFor="let breadcrumb of topbarHeader.breadCrumbs; let i = index">
          <div class="flex items-center gap-1.5">
            <!-- Mostrar ícono solo para el primer breadcrumb -->
            <app-icon-wrapper
              *ngIf="i === 0"
              [color]="'#B0B0B0'"
              [size]="'small-medium'"
              [icon]="$any(topbarHeader.icon || 'cog')" />
            <div class="flex justify-center items-center">
              <a
                [routerLink]="breadcrumb.route || (backRoute$ | async)"
                [class]="
                  breadcrumb.isLast
                    ? 'text-neutral-600 dark:text-night-300 font-medium text-sm leading-5'
                    : 'text-neutral-400 dark:text-night-400 font-normal text-sm leading-5'
                ">
                {{ breadcrumb.label }}
              </a>
            </div>
          </div>
          <!-- Agregar chevron si no es el último -->
          <div class="flex items-center gap-2" *ngIf="!breadcrumb.isLast">
            <app-icon-wrapper
              [color]="'#B0B0B0'"
              [size]="'small-medium'"
              icon="chevron-right" />
          </div>
        </ng-container>
      </div>
      <div class="flex items-center gap-2">
        <a
          *ngIf="backRoute$ | async as backRoute"
          [routerLink]="backRoute"
          class="flex items-center cursor-pointer text-primary-600 dark:text-night-300 hover:opacity-80 transition-opacity">
          <app-icon-wrapper
            [color]="'currentColor'"
            [size]="'medium-large'"
            icon="chevron-left" />
        </a>
        <span
          class="font-semibold text-2xl sm:text-3xl lg:text-[32px] leading-tight lg:leading-10 text-primary-600 dark:text-night-50 break-words min-w-0">
          {{ topbarHeader.title }}
        </span>
      </div>
    </nav>
    <div
      class="flex items-center w-full lg:w-auto shrink-0 lg:basis-auto">
      <ul
        class="flex flex-row flex-wrap justify-end items-center pl-0 mb-0 w-full list-none gap-3">
        <li class="relative flex items-center">
          <a
            [routerLink]="ROUTES.DOCS"
            aria-label="Documentación"
            class="flex items-center justify-center rounded-lg bg-white dark:bg-night-900 shadow-lg p-4 cursor-pointer">
            <app-icon-wrapper
              [color]="'currentColor'"
              [size]="'medium-large'"
              class="text-primary-600 dark:text-night-300"
              icon="document" />
          </a>
        </li>
        <li class="relative flex items-center" data-tour="config">
          <a
            [routerLink]="ROUTES.CONFIG_GENERAL"
            class="flex items-center justify-center rounded-lg bg-white dark:bg-night-900 shadow-lg p-4 cursor-pointer">
            <app-icon-wrapper
              [color]="'currentColor'"
              [size]="'medium-large'"
              class="text-primary-600 dark:text-night-300"
              icon="cog" />
          </a>
        </li>
        <li class="relative flex items-center">
          <button
            (click)="toggleTheme()"
            aria-label="Cambiar tema"
            [attr.aria-pressed]="isDark()"
            class="flex items-center justify-center rounded-lg bg-white dark:bg-night-900 shadow-lg p-4 cursor-pointer">
            <app-icon-wrapper
              [color]="'currentColor'"
              [size]="'medium-large'"
              class="text-primary-600 dark:text-night-300"
              [icon]="isDark() ? 'moon' : 'sun'" />
          </button>
        </li>
        <li class="relative flex items-center">
          @if (isAdmin()) {
            <app-company-selector />
          } @else {
            <img
              *ngIf="
                organizationCompany()?.managementFile?.blobUrl;
                else fallbackAvatar
              "
              [src]="organizationCompany()!.managementFile!.blobUrl"
              alt="Logo empresa"
              class="w-14 h-full rounded-lg object-contain" />
            <ng-template #fallbackAvatar>
              <div
                class="flex items-center justify-center rounded-lg bg-white dark:bg-night-900 shadow-lg w-14 h-full">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28.28 26.4L1.88 0L0 1.88L3.08 4.97333V22.5333C3.08 24 4.28 25.2 5.74667 25.2H23.3067L26.3867 28.28L28.28 26.4ZM5.74667 21.2L10.4133 15.2L13.7467 19.2133L15.3067 17.2L19.3067 21.2H5.74667ZM27.08 21.4267L6.85333 1.2H24.4133C25.88 1.2 27.08 2.4 27.08 3.86667V21.4267Z"
                    fill="#E7E7E7" />
                </svg>
              </div>
            </ng-template>
          }
        </li>
        <li class="relative flex items-center">
          <button
            class="flex items-center gap-8 rounded-lg bg-white dark:bg-night-900 shadow-lg py-2.5 px-3 cursor-pointer"
            aria-label="Menú de usuario"
            (click)="dropdownMenu.toggle($event)">
            <div
              class="flex items-center justify-center font-semibold gap-2.5 flex-col rounded-full bg-neutral-50 dark:bg-night-800 text-primary-600 dark:text-night-300 uppercase h-8 w-8">
              {{ getShortName() }}
            </div>
            <div class="flex flex-col items-start">
              <span class="hidden sm:block text-sm font-normal">
                {{ userPerson()?.firstname }} {{ userPerson()?.lastname }}
              </span>
              <span
                class="hidden sm:block text-xs font-normal text-neutral-600 dark:text-night-300">
                {{ organizationCompany()?.tradeName }}
              </span>
            </div>
            <app-icon-wrapper
              class="hidden sm:block"
              [color]="'#8F95A1'"
              [size]="'medium-large'"
              icon="chevron-down" />
          </button>
          <p-menu
            [model]="menuItems"
            #dropdownMenu
            class="menu-custom"
            [popup]="true">
            <ng-template pTemplate="start">
              <div
                class="hidden sm:flex mr-2 flex-col p-4 items-center gap-2 border-custom">
                <div
                  class="flex flex-col items-center justify-center w-12 h-12 gap-2.5 rounded-full bg-primary-600">
                  <span class="text-base text-white font-semibold uppercase">{{
                    getShortName()
                  }}</span>
                </div>
                <div
                  class="hidden sm:block text-sm text-center font-semibold text-neutral-800 dark:text-night-50">
                  {{ userPerson()?.firstname }} {{ userPerson()?.lastname }}
                </div>
                <div
                  class="hidden sm:block text-xs text-center font-normal text-neutral-500 dark:text-night-400">
                  {{ userPerson()?.email }}
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <a
                pRipple
                class="flex align-items-center p-menuitem-link py-2 px-4 gap-2 cursor-pointer">
                <span [class]="item.icon + ' text-destructive-500'"></span>
                <span class="hidden sm:block text-destructive-500">{{
                  item.label
                }}</span>
              </a>
            </ng-template>
          </p-menu>
        </li>
      </ul>
    </div>
  </div>
</nav>
